export default "__VITE_ASSET__CO1XQt_t__"